import React from 'react';
import { Row, Span } from "components";
import { FONTS, SPACING } from 'utils';

interface LegendaProps {
  status: string;
}
const statusColors = {
  Bloqueado: '#A020F0',
  Liberado: '#81C784',
  Pendente: 'YELLOW',
  Demitido: '#DB5461'
};
function getColor(status: string) {
  return statusColors[status] || '#81C784'; // Substitua 'defaultColor' pela cor padrão desejada
}
export default function LegendasEfetivoLogico({ status }: LegendaProps) {
  return (
    <>
      <Row justifyContent="flex-end" marginBottom={SPACING.spacing20} marginRight={SPACING.spacing20} gap={SPACING.spacing20}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <svg height="20" width="20" style={{ fill: getColor(status) }}>
            <circle cx="10" cy="10" r="10" />
          </svg>
          <Span
            text={status}
            style={{ fontWeight: FONTS.bold, fontFamily: 'Arial, Helvetica, sans-serif' }}
            marginLeft={SPACING.spacing5}
          />
        </div>
      </Row>
    </>
  )
}
